export default function React_Quiz() {
  return (
    <div>
      <h1>React_Quiz Component</h1>
      <p>This is the React_Quiz tutorial page.</p>
    </div>
  );
}
